import { SearchComponent } from './partials/search/search.component';
import { SidebarComponent } from './partials/sidebar/sidebar.component';
import { SidebarItemComponent } from './partials/sidebar-item/sidebar-item.component';
import { HeaderComponent } from './partials/header/header.component';
import { BreadcrumbComponent } from './partials/breadcrumb/breadcrumb.component';
import { ToolbarComponent } from '../toolbar/components/toolbar/toolbar.component';
import { TenantsModalComponent } from '@kaiser-software/chassis-core/src/app/layouts/components/partials/tenants-modal/tenants-modal.component';

export const PARTIALS = [
    SearchComponent,
    ToolbarComponent,
    BreadcrumbComponent,
    SidebarItemComponent,
    SidebarComponent,
    HeaderComponent,
    TenantsModalComponent
];



// WEBPACK FOOTER //
// ./libs/chassis-core/src/app/layouts/components/partials.ts